export default __webpack_public_path__ + "static/media/SAS0090.34I-41824_-25109_0.3010170e.jpg";